import type { ComponentProps } from 'react';
import { cn } from '@src/design-system/helpers';

export function EditableCell({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'cursor-pointer outline-1 px-2 -outline-offset-1 outline-transparent hover:outline-pale-border rounded-sm absolute inset-0 flex items-center',
        'has-data-[state=open]:outline-active-border',

        className
      )}
      {...props}
    />
  );
}
